import { AxiosError } from "axios";

import instance from "./axios";

export async function getDetailsCollection(uidCollection: string) {
  try {
    const res = await instance.get(`/main/collection/uid/${uidCollection}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (e) {
    console.log(`[GET_DETAILS_COLLECTION] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getAllCollections() {
  try {
    const res = await instance.get(`/main/collection/all`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (e) {
    console.log(`[GET_DETAILS_COLLECTION] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getSeries() {
  try {
    const response = await instance.get(`/main/home/v2`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSerieInfo(idSerie: string | undefined) {
  try {
    const response = await instance.get(`/main/serie/${idSerie}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function loadEpFile(
  idEp: string | undefined,
  next: boolean,
  infosEp: boolean
) {
  try {
    const response = await instance.get(
      `/main/serie/episode/${idEp}?next=${next}&infosEp=${infosEp}&v=2`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error: any) {
    console.error(error.response);
    return error.response;
  }
}
export async function getInfoEp(
  idEp: string | undefined,
) {
  try {
    const response = await instance.get(
      `/main/serie/v2/episode/${idEp}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error: any) {
    console.error(error.response);
    return error.response;
  }
}

export async function putMarkedNode(body: {
  epId: string | undefined;
  nodeId: number;
  lastNode: boolean | undefined;
}) {
  try {
    await instance.put(`/main/serie/episode/saveMarkedNode`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (e: any) {
    console.log("[REQUEST] putMarkedNode", e.message);
  }
}

export async function getProfils() {
  try {
    const response = await instance.get(`/main/webapp/profil`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function postActivateStripeSub() {
  try {
    const response = await instance.post(
      `/main/webapp/sub/activate`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function postCancelStripeSub() {
  try {
    const response = await instance.post(
      `/main/webapp/sub/cancel`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export type UnlockedSerie = {
  idSerie: number;
  name: string;
  img: string;
};

export type UnlockSerieResponse =
  | { isOk: true; series: UnlockedSerie[] }
  | { isOk: false; msg: string };

export async function unlockSerieProf(code: string): Promise<UnlockSerieResponse> {
  try {
    const res = await instance.post(
      `/main/webapp/reward`,
      {
        code,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (e) {
    console.error(e);
    // Some refusals (code already used, premium only...) come back as 403/404 with a message
    const data = (e as AxiosError<{ msg?: string }>).response?.data;
    return {
      isOk: false,
      msg: data?.msg || "Impossible de vérifier ce code pour le moment. Vérifiez votre connexion puis réessayez.",
    };
  }
}

export async function refreshToken() {
  try {
    const response = await instance.post(
      `/main/webapp/refresh`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}
